import React, { useMemo } from 'react'
import { motion } from 'framer-motion'
import { createColumnHelper } from '@tanstack/react-table'
import { Table } from '@demandlocal/components'
import { Link } from 'react-router-dom'
import { useGetPaginatedDealerSocketDealerships } from '../../../../api/admin/useGetPaginatedDealerSocketDealerships'

type DealerSocketCol = {
  id: number
  _id: string
  dealership: string
}

const columnHelper = createColumnHelper<DealerSocketCol>()

export default function DealerSocket(): JSX.Element {
  const columns = useMemo(
    () => [
      columnHelper.accessor('id', {
        header: () => 'ID',
        cell: (info) => info.getValue(),
        enableSorting: false,
      }),
      columnHelper.accessor('dealership', {
        header: () => 'Dealership',
        cell: (info) => info.getValue(),
        enableSorting: false,
      }),
      columnHelper.display({
        id: 'mapped',
        header: () => 'Mapped To',
        cell: ({ row }) => {
          return (
            <Link
              to={`../../../dealerships/${row.original._id}/edit`}
              className="text-primary-persian-blue font-bold">
              {row.original.dealership}
            </Link>
          )
        },
      }),
    ],
    [],
  )

  return (
    <motion.div className="flex flex-col gap-2 pt-5">
      <Table
        columns={columns}
        filters={{}}
        fetchFn={useGetPaginatedDealerSocketDealerships}
      />
    </motion.div>
  )
}
